import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import SideNav from './Partials/SideNav';
import { qprService } from '../../../../Services';
import { qprActions } from '../../../../Actions';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

const PlanForRemainingQuarterForm = () => {
  const location = useLocation();
  const { qpr_id, qh } = location.state;
  const qpr = useSelector((state) => state.qpr_data);
  const dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  const [drafted, setDrafted] = useState(false);

  const [input, setInput] = useState(qpr.plan_for_remaining_quarter && qpr.plan_for_remaining_quarter.prq && qpr.plan_for_remaining_quarter.prq.length > 0? qpr.plan_for_remaining_quarter.prq: [{
    timeline: '',
    planned_activities: '',
  }]);

  useEffect( () => {
    if(typeof qpr.plan_for_remaining_quarter == "undefined") {
      qprService.planForRemainingQuarter(qpr_id).then(rslt => {
        qpr.plan_for_remaining_quarter = rslt.data.plan_for_remaining_quarter;
        qpr.form_validation = JSON.parse(rslt.data.plan_for_remaining_quarter.form_validation);
        localStorage.setItem("qpr_data", JSON.stringify(qpr));
        dispatch(qprActions.qprData(qpr));
        setInput(qpr.plan_for_remaining_quarter.prq);
      });
    }
  }, []);

  const addInputField = () => {
    setInput([...input, {
      timeline: '',
      planned_activities: '',
    }])
  }
  
  const removeInputFields = (index) => {
    const rows = [...input];
    rows.splice(index, 1);
    setInput(rows);
  }

  const [validationError, setValidationError] = useState([{timeline: null, planned_activities: null}]);
  const ref = useRef([]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...input];
    list[index][name] = value;
    setInput(list);
  }

  const checkValidation = () => {
    let error = {};
    Object.keys(input).map(item => {
      if(input[item] == "" && item != "user_status") {
        error[item] = "Required";
      }
    });

    if(Object.keys(error).length>0) {
      setValidationError(error);
      const ref_focus_key = Object.keys(error)[0];
      ref.current[ref_focus_key].focus();
    }
    return error;
  }

  const submitForm = (submit_status, fnctn) => {
    setValidationError({});
    let input_data = {plan: input};
    qpr.form_validation.plan_for_remaining_quarter.submit_status = 0;
    input_data.submit_status = 0;
    if(submit_status == 1) {
      qpr.form_validation.plan_for_remaining_quarter.submit_status = 1;
      input_data.submit_status = 1;
      if(Object.keys(checkValidation()).length > 0) {
        fnctn(false);
        return false;
      }
    }
    input_data.form_validation = JSON.stringify(qpr.form_validation);
    qprService.planForRemainingQuarterSave(input_data, qpr_id).then(res => {
      qpr.plan_for_remaining_quarter = res.data.plan_for_remaining_quarter;
      localStorage.setItem("qpr_data", JSON.stringify(qpr));
      dispatch(qprActions.qprData(qpr));
      fnctn(false);
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let submit_status = e.target.dataset.submit_status;
    let fnctn = submit_status==1? setSubmitted: setDrafted;
    fnctn(true);
    submitForm(submit_status, fnctn);
  }
  
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>{qh}</h5>
              </div>
              <div className='row mt-4'>
                <div className='col-md-4'>
                  <SideNav />
                </div>
                <div className='col-md-8'>
                  <div className='card border-info' style={{"borderTop": "3px solid"}}>
                    <div className='card-header'><h6>Plan For Remaining Quarters</h6></div>
                    <div className="contact-from pt-0">
                      <div className="main-form">
                        <form onSubmit={handleSubmit} data-submit_status={1}>
                          <div className='singel-form' id='field-container'>
                            {input.map((data, index) => {
                              return (<div className="row" key={index}>
                                <div className='col-md-4'>
                                  <label>Timeline<span className='text-danger'>*</span>:</label>
                                  <input type="text" name='timeline' value={data.timeline} onChange={e => handleChange(index, e)} data-error="Timeline is required." />
                                  {/* {validationError[index].timeline && <span className='text-danger'>{validationError[index].timeline}</span>} */}
                                </div>
                                <div className='col-md-7' >
                                  <label >Planned activities<span className='text-danger'>*</span>:</label>
                                  <input type="text" name='planned_activities' value={data.planned_activities} onChange={e => handleChange(index, e)} data-error="Planned activities is required" />
                                  {/* {validationError[index].planned_activities && <span className='text-danger'>{validationError[index].planned_activities}</span>} */}
                                </div>
                                <div className='col-md-1 pt-4 mt-3'>
                                  {(input.length!==1)? 
                                    <button type="button" className='btn btn-sm btn-danger' onClick={() =>  removeInputFields(index)}>
                                      <FontAwesomeIcon icon={faMinus} />
                                    </button>:''}
                                </div>
                              </div>)
                            })}
                          </div>
                          <div className='singel-form'>
                            <button type="button" className='btn btn-sm btn-info' onClick={addInputField}>
                              <FontAwesomeIcon icon={faPlus} /> 
                            </button>
                          </div>
                          <hr/>
                          <p className="form-message"></p>
                          <div className="singel-form">
                            <button type="button" className="main-btn btn-info btn-outline-info disabled" onClick={submitted? '': handleSubmit} data-tip data-for="draft">
                              {drafted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Draft</span>}
                            </button>
                            <ReactTooltip id="draft" place="top" effect="solid">
                              You can save the form as draft if you do not have all the required information to fill
                            </ReactTooltip>
                            <button type={submitted? "button": "submit"} className="main-btn btn-info ml-3 disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Save</span>}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PlanForRemainingQuarterForm;